import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';

Component('tr-project-todolists-toolbar', {
  mixins: [eventListenerMixin],

  connected() {},

  disconnected() {
    this.stopListening();
  },
});
